import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { screeningAction } from '../../actions/constant';
import screeningService from '../../../services/apiServices/screeningDetails/screeningDetails';
const { GET_SINGLE_SCREENING_REQUEST, GET_SINGLE_SCREENING_SUCCESS, GET_SINGLE_SCREENING_FAILURE } = screeningAction;

function* getSingleScreening(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(screeningService.getSingleScreening, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_SINGLE_SCREENING_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_SINGLE_SCREENING_FAILURE, payload: error });
  }
}

function* getSingleScreeningSaga() {
  yield takeEvery(GET_SINGLE_SCREENING_REQUEST, getSingleScreening);
}

export default getSingleScreeningSaga;
